import styled from 'styled-components'
import Capa from '../../../assets/capa1.webp' // Ajuste o caminho se necessário

// Reduzido o padding no mobile para aproveitar melhor a tela
export const Page = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #f7f7fb 0%, #eef0ff 45%, #fdf7f3 100%);
  padding: 1.5rem 1rem 3rem;

  @media (min-width: 768px) {
    padding: 2.5rem 1.25rem 4rem;
  }
`

// No mobile, exibe em coluna. No desktop (1024px), volta para o grid lado a lado
export const Shell = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  /* AJUSTE AQUI: Garante que os itens fiquem centralizados se houver sobra de espaço */
  align-items: center;

  @media (min-width: 1024px) {
    display: grid;
    /* Deixei o template-columns mais flexível caso haja apenas 1 elemento no form (ex: Parceiro) */
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    justify-content: center;
    align-items: start;

    /* Se tiver só um filho (como no login do parceiro), ele centraliza na tela toda */
    &:has(> :last-child:nth-child(1)) {
      display: flex;
    }
  }
`

// Para o form do parceiro que tem um inline-style maxWidth: 500px, isso garante a centralização
export const Card = styled.div`
  background: #fff;
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 10px 40px rgba(25, 27, 53, 0.08);
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  width: 100%; /* Garante que preencha o espaço pai até o limite do maxWidth */

  @media (min-width: 768px) {
    padding: 2.25rem;
    border-radius: 20px;
    gap: 2rem;
    box-shadow: 0 20px 60px rgba(25, 27, 53, 0.12);
  }
`

export const CardHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  gap: 0.5rem;
  background: rgba(137, 118, 255, 0.12);
  color: var(--purple);
  border-radius: 999px;
  padding: 0.35rem 0.9rem;
  font-weight: 700;
  font-size: 0.875rem;
`

export const Subtitle = styled.p`
  margin: 0;
  color: #575b71;
  font-weight: 600;
  font-size: 0.95rem;
`

export const Stepper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: 640px) {
    flex-direction: row;
    gap: 0.75rem;
  }
`

export const Step = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 12px;
  background: #f6f7fb;
  border: 1px solid transparent;
  flex: 1;

  &.active {
    background: #ffffff;
    border-color: var(--purple);
    box-shadow: 0 4px 15px rgba(116, 92, 255, 0.1);
  }

  &.muted {
    opacity: 0.75;
  }
`

export const StepIndex = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 800;
  font-size: 0.9rem;
  color: #fff;
  background: #d2d5eb;
  flex-shrink: 0;

  &.active {
    background: var(--purple);
  }

  &.muted {
    background: #dfe3f5;
    color: #71758f;
  }
`

export const StepLabel = styled.div`
  display: flex;
  flex-direction: column;

  strong {
    color: #1f2241;
    font-size: 0.9rem;
  }

  span {
    color: #6b6f83;
    font-size: 0.8rem;
  }
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;

  @media (min-width: 640px) {
    grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
    gap: 1.25rem 1rem;
  }
`

export const InputField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.4rem;

  &.full {
    grid-column: 1 / -1;
  }

  label {
    font-size: 0.9rem;
    font-weight: 700;
    color: #1f2241;
  }

  input,
  select {
    width: 100%;
    background: #f8f8ff;
    border: 1px solid #e4e7f5;
    color: var(--black);
    font-weight: 700;
    padding: 14px 16px;
    border-radius: 10px;
    font-size: 16px;
    outline-color: var(--purple);
    transition: all 0.2s ease;

    &:focus {
      border-color: var(--purple);
      box-shadow: 0 0 0 4px rgba(116, 92, 255, 0.15);
      background: #fff;
    }
  }
`

export const SpanError = styled.div`
  font-size: 0.8rem;
  color: #d7263d;
  font-weight: 600;
  margin-top: 2px;
`

export const Actions = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 1.25rem;

  @media (min-width: 640px) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`

export const HelperNote = styled.p`
  margin: 0;
  color: #4b4f68;
  font-weight: 600;
  font-size: 0.9rem;
  text-align: center;

  @media (min-width: 640px) {
    text-align: left;
  }
`

export const ButtonOrange = styled.button`
  background: linear-gradient(120deg, #ff9134, #ff7b1c);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 1rem 1.5rem;
  border: none;
  color: #fff;
  font-weight: 800;
  font-size: 1rem;
  border-radius: 12px;
  width: 100%;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.2s ease, filter 0.15s ease;
  box-shadow: 0 8px 20px rgba(255, 145, 52, 0.25);

  &:hover {
    transform: translateY(-2px);
    filter: brightness(1.05);
    box-shadow: 0 12px 25px rgba(255, 145, 52, 0.35);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
    box-shadow: none;
    transform: none;
  }

  @media (min-width: 640px) {
    width: auto;
    min-width: 240px;
  }
`

export const SideCard = styled.div`
  position: relative;
  background: linear-gradient(160deg, rgba(98, 63, 168, 0.95), rgba(255, 132, 44, 0.85)),
  url(${Capa}) center/cover no-repeat;
  color: #fff;
  border-radius: 16px;
  padding: 1.5rem;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(39, 39, 72, 0.2);
  width: 100%; /* Adicionado para preencher o grid */

  &:before {
    content: '';
    position: absolute;
    inset: 0;
    background: radial-gradient(circle at 20% 20%, rgba(255, 255, 255, 0.12), transparent 35%),
    radial-gradient(circle at 80% 30%, rgba(255, 255, 255, 0.1), transparent 40%);
    pointer-events: none;
  }

  > * {
    position: relative;
    z-index: 1;
  }

  @media (min-width: 1024px) {
    padding: 2rem;
    min-height: 100%;
    border-radius: 20px;
  }
`

export const SideBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.35rem 0.85rem;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 999px;
  font-weight: 700;
  font-size: 0.85rem;
`

export const SideTitle = styled.h3`
  margin: 1rem 0 0.75rem 0;
  font-size: 1.3rem;
  color: #fff;
`

export const SideList = styled.ul`
  margin: 0;
  padding: 0 0 0 1.25rem;
  display: grid;
  gap: 0.75rem;

  li {
    line-height: 1.4;
    font-weight: 600;
    color: #f9f9ff;
    font-size: 0.9rem;
  }
`
